import React, { useState } from 'react';
import botAPI from '../botAPI.js';

const Footer = React.memo(function Footer({ onNavigate }) {
  const year = new Date().getFullYear();
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleted, setDeleted] = useState(false);

  const handlePrivacyPolicy = () => {
    if (onNavigate) {
      onNavigate('privacy');
    } else {
      window.open('/privacy', '_blank');
    }
  };

  const handleDeleteData = () => {
    setShowConfirm(true);
  };

  const confirmDelete = () => {
    // Очищаем cookie consent из localStorage
    localStorage.removeItem('cookie_consent');
    // Записываем отзыв согласия на сервер
    botAPI.sendCookieConsent('withdrawn').catch(() => {});
    setShowConfirm(false);
    setDeleted(true);
    setTimeout(() => setDeleted(false), 3000);
  };

  return (
    <footer className="border-t border-gray-200/60 dark:border-gray-700/40 mb-[60px] xl:mb-0">
      <div className="max-w-[1200px] mx-auto py-4 px-4 xl:px-6">
        <div className="flex items-center justify-between sm:justify-center sm:gap-6">
          <span className="text-xs text-[#94a3b8] dark:text-[#64748b]">
            &copy; {year} Путь рыбы
          </span>
          <span className="text-[#d1d5db] dark:text-[#475569] hidden sm:inline">&middot;</span>
          <button
            onClick={handlePrivacyPolicy}
            className="text-xs text-[#64748b] dark:text-[#94a3b8] hover:text-gray-700 dark:hover:text-gray-300 transition-colors bg-transparent border-none cursor-pointer py-3 px-1 min-h-[44px] flex items-center"
          >
            Конфиденциальность
          </button>
          <span className="text-[#d1d5db] dark:text-[#475569] hidden sm:inline">&middot;</span>
          <button
            onClick={handleDeleteData}
            className="text-xs text-[#64748b] dark:text-[#94a3b8] hover:text-gray-700 dark:hover:text-gray-300 transition-colors bg-transparent border-none cursor-pointer py-3 px-1 min-h-[44px] flex items-center"
          >
            Удалить данные
          </button>
        </div>

        {/* Подтверждение удаления cookie */}
        {showConfirm && (
          <div className="flex items-center justify-center gap-3 pt-2 pb-1">
            <span className="text-xs text-gray-500 dark:text-gray-400">Удалить cookies и данные согласия?</span>
            <button
              onClick={confirmDelete}
              className="text-xs text-red-500 hover:text-red-600 font-medium bg-transparent border-none cursor-pointer p-0"
            >
              Да, удалить
            </button>
            <button
              onClick={() => setShowConfirm(false)}
              className="text-xs text-gray-400 hover:text-gray-600 bg-transparent border-none cursor-pointer p-0"
            >
              Отмена
            </button>
          </div>
        )}

        {/* Уведомление об удалении */}
        {deleted && (
          <div className="text-center py-1">
            <span className="text-xs text-emerald-500">Данные cookie удалены</span>
          </div>
        )}
      </div>
    </footer>
  );
});

export default Footer;
